module.exports = __webpack_public_path__ + "img/bbva-MODO.efb9e39c.svg";